import graphqlClient from "@/GQLClient";
import { type InstitutionsEmployeeFragment } from "@/graphql";
import {
  SaveEmployeeDocument,
  GetInstitutionsEmployeesDocument,
  type EmployeeInput,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import { useAuthStore } from "@/stores/auth.module";

const getEmployees = async (): Promise<InstitutionsEmployeeFragment[]> => {
  const response = await graphqlClient.query({
    query: GetInstitutionsEmployeesDocument,
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  });

  if (response.data.institutions?.getMyInstitution.employees) {
    const employees =
      response.data.institutions.getMyInstitution.employees.toSorted((a, b) => {
        const aValue = a.displayName || a.name || a.surname || "";
        const bValue = b.displayName || b.name || b.surname || "";
        return aValue.localeCompare(bValue);
      });

    return employees as InstitutionsEmployeeFragment[];
  }

  throw new SentryGraphQLError(`api.employees.getEmployees`, response);
};

const save = async (employee: EmployeeInput) => {
  const authStore = useAuthStore();
  employee.institution = authStore.institutionId;

  const response = await graphqlClient.query({
    query: SaveEmployeeDocument,
    variables: {
      employee,
    },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  });

  if (response.data.user?.saveProfile?.success) {
    return response;
  }

  throw new SentryGraphQLError(`api.employees.save`, response);
};

export default {
  getEmployees,
  save,
};
